import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useUserData(selectedCompanyId?: number) {
    const { data: users, isPlaceholderData: isPlaceholderDataUsers } = useQuery({
        queryKey: [QueryKey.USERS_WITHOUT_EMPLOYEE, selectedCompanyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.salary.employees.users.get'));
            return data;
        },
        placeholderData: [],
        enabled: !!selectedCompanyId,
    });

    return {
        users,
        isPlaceholderDataUsers,
    };
}
